module.exports = __webpack_public_path__ + "img/legende150.bb7dd897.jpg";